import React from 'react';

import UseStateExample from './hooks/use-state-example.component';

import '../App.css';

const HooksExample = props => {
  return <UseStateExample />;
};

export default HooksExample;